import { render, staticRenderFns } from "./CCItem.vue?vue&type=template&id=565297f7&"
import script from "./CCItem.vue?vue&type=script&lang=js&"
export * from "./CCItem.vue?vue&type=script&lang=js&"
import style0 from "./CCItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports